// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yoBny","content":"styles_content__vuscm","container":"styles_container__sFTvO","breadcrumbs":"styles_breadcrumbs__fdkd0"};